import { render, staticRenderFns } from "./am-process.vue?vue&type=template&id=fd2ddd62&scoped=true"
import script from "./am-process.vue?vue&type=script&lang=ts"
export * from "./am-process.vue?vue&type=script&lang=ts"
import style0 from "./am-process.vue?vue&type=style&index=0&id=fd2ddd62&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2ddd62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd2ddd62')) {
      api.createRecord('fd2ddd62', component.options)
    } else {
      api.reload('fd2ddd62', component.options)
    }
    module.hot.accept("./am-process.vue?vue&type=template&id=fd2ddd62&scoped=true", function () {
      api.rerender('fd2ddd62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/am-process/am-process.vue"
export default component.exports